import { settingsTexts } from 'consts/text';
import { LabelMapper, SettlementConfiguration } from 'types';

export const settlementConfigurationLabels: LabelMapper<SettlementConfiguration> = {
    POSTPAID: settingsTexts.settlements.meals.formLabels.postPaid,
    PREPAID: settingsTexts.settlements.meals.formLabels.prePaid,
};
